<div>
  <div style="margin-left: 50%; margin-bottom: 2%;">
    <button mat-raised-button color="primary" (click)="saveSubscriptionBarcodesDataEntry()">
      Save
    </button>

    <button class="noPrint" style="margin-right: 2%; margin-left: 2%" (click)="exportExcel('Vatnaval_Data')"
      mat-raised-button color="primary">
      Export
    </button>

    <!-- <button class="noPrint" style="margin-left: 10px" mat-raised-button color="primary" printSectionId="print-section"
      ngxPrint>
      Print
    </button> -->

    <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
      (click)="printPage()"> Print
    </button>

    <button mat-dialog-close class="btn noPrint">Close</button>
  </div>

  <div class="container">
    <div id="print-section">

      <!-- HEADER -->
      <!-- <div style="display: flex; justify-content: space-between; align-items: center;">
        <img src="../../../assets/img/brand/red.png" alt="logo" width="100" height="100">

        <div style="margin-top: 25px;">
          <b>हिंदुस्थान प्रकाशन संस्था</b><br>
          116-119, शिल्पीन सेंटर, वडाळा, मुंबई - 400031<br>
          दूरध्वनी: 9967570531
        </div>

        <div>
          दिनांक - {{ today | date:'dd-MM-yyyy' }}
        </div>
      </div> -->


      <div class="row">
        <div class="col-3">
          <img src="../../../assets/img/brand/red.png" alt="logo" width="100" height="100">
        </div>
        <div class="col-6" style="margin-top: 25px;">
          <span style="font-size: 18px;">
            हिंदुस्थान प्रकाशन संस्था <br>
            116-119, शिल्पीन सेंटर, पहिला मजला, गं. द. आंबेकर मार्ग, <br>
            वडाळा, मुंबई - 400 031 दूरध्वनीः 9967570531
          </span>

        </div>
        <div class="col-3" style="margin-top: 15px;">
          <span style="font-size: 17px;">दिनांक - {{ today | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>

      <!-- TABLE -->
      <table border="1" width="100%" style="margin-top: 15px; border-collapse: collapse; text-align: center;">

        <!-- HEADER ROW -->
        <thead>
          <tr>
            <th [attr.colspan]="4 + sundayDates.length + 9" style="text-align: center; color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते वाटणावळ - {{
              getMonthYearInMarathi(startDate, endDate) }}</th>
          </tr>
          <tr>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अ.क्र</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">प्रतिनिधीचे नाव</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">ठिकाण</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">वाटणावळ दर</th>

            <!-- ✅ Dynamic Sundays -->
            <th *ngFor="let sunday of sundayDates" style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ sunday }}
            </th>

            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अंक संख्या</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">वाटणावळ रक्कम</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">मागील वाटणावळ</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">मागील थकबाकी</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण वाटणावळ</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अकाऊंट पेमेंट</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अकाऊंट शिल्लक वाटणावळ</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अकाऊंट दिनांक</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">शेरा</th>


          </tr>
        </thead>

        <!-- BODY -->
        <tbody>
          <tr *ngFor="let item of yourData; let i = index">

            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ i + 1 }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.name }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.thikan }}</td>

            <!-- Rate Input -->
            <td style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              <input *ngIf="!show" type="number" [(ngModel)]="item.vatnavl_Rate" (input)="calculateRow(item)"
                style="width: 60px; height: 35px; text-align: center; color: black;">
              <!-- print साठी -->
              <span *ngIf="show">
                {{ item.vatnavl_Rate || 0 }}
              </span>
            </td>

            <!-- ✅ Sunday Data -->
            <td *ngFor="let sunday of sundayDates" style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ item[sunday] || 0 }}
            </td>

            <!-- Other Columns -->
            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.total_Ank || 0 }}</td>
            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.vatnaval_Total || 0}}</td>
            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.previous_Vatnaval || 0 }}</td>
            <td style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              <input *ngIf="!show" type="number" [(ngModel)]="item.description" (input)="calculateRow(item)"
                style="width: 60px; height: 35px; text-align: center; color: black;">
              <span *ngIf="show">
                {{ item.description || 0 }}
              </span>
            </td>

            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.all_Vatnaval_Amount || 0 }}</td>
            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.exp_amt }}</td>
            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.remaining_Vatnaval_Amount }}</td>
            <td style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.d_voucher_date }}</td>
            <td style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              <input *ngIf="!show" type="text" [(ngModel)]="item.description1"
                style="width: 60px; height: 35px; text-align: center; color: black;">
              <span *ngIf="show">
                {{ item.description1 || 0 }}
              </span>
            </td>


          </tr>
        </tbody>

        <!-- FOOTER TOTAL -->
        <tfoot>
          <tr style="font-weight: bold; background: #f2f2f2; color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
            <td colspan="4">एकूण</td>

            <!-- ✅ Sunday totals -->
            <td *ngFor="let sunday of sundayDates" style="color: black;  border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ getSundayTotal(sunday) }}
            </td>

            <!-- ✅ Fixed totals -->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getTotalAnk() }}</td> <!-- अंक संख्या -->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getVatnavalTotal() }}</td> <!-- वाटणावळ रक्कम -->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getPreviousTotal() }}</td> <!-- मागील वाटणावळ -->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getAllPastDueAmount() }}</td> <!-- मागील थकबाकी -->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getAllVatnavalTotal() }}</td> <!-- एकूण वाटणावळ-->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{getAccountPaymentAmount() }}</td>  <!-- अकाऊंट पेमेंट-->
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getAllRemainingTotal() }}</td>  <!-- अकाऊंट शिल्लक वाटणावळ-->
            <td style=" border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;"></td>
            <td style=" border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;"></td>
          </tr>
        </tfoot>

        
      </table>

      <!-- ✅ Signature Section -->
      <div style="display: flex; justify-content: flex-end; margin-top: 10px;">

        <div style="text-align: center; width: 250px;">

          <!-- Space for signature -->
          <div style="height: 10px;"></div>

          <!-- Signature Label -->
          <div style="font-weight: 600; color: black;">
            स्वाक्षरी
          </div>

          <!-- Department Head -->
          <div style="margin-top: 50px; color: black;">
            वर्गणी विक्री विभाग
          </div>

          <!-- Date -->
          <div style="margin-top: 5px; color: black;">
            दिनांक: {{ today | date:'dd/MM/yyyy' }}
          </div>

        </div>

      </div>

    </div>




  </div>
</div>